import { render, staticRenderFns } from "./PointsListModal.vue?vue&type=template&id=5188e7e2&scoped=true&"
import script from "./PointsListModal.vue?vue&type=script&lang=js&"
export * from "./PointsListModal.vue?vue&type=script&lang=js&"
import style0 from "./PointsListModal.vue?vue&type=style&index=0&id=5188e7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5188e7e2",
  null
  
)

export default component.exports